module.exports = __webpack_public_path__ + "img/face-grin-tears.0806453e.svg";